import React, { useEffect, useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import axios from 'axios';
import supporticon from '../assets/images/support_icon.svg';
import xlogofooter from '../assets/images/x_logo_footer.png';
import config from '../config/config';

const Footer = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const currentYear = new Date().getFullYear();
  const [siteSettings, setSiteSettings] = useState({
    twitter_link: '',
    insta_link: '',
  });

  useEffect(() => {
    const fetchSiteSettings = async () => {
      try {
        const response = await axios.get(`${config.baseURL}/get-site-settings`);
        if (response.data.success) {
          setSiteSettings(response.data.data);
        }
      } catch (error) {
        console.error('Failed to fetch site settings:', error);
      }
    };

    fetchSiteSettings();
  }, []);


  const handleLinkClick = (e, hash) => {
    e.preventDefault();
    navigate(hash);
    const element = document.getElementById(hash.substring(1));
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const isHelpPage = location.pathname.includes('/help');


  return (
    <footer className="footer-area bg-img bg-s-cover">
      <div className="footer-top pt-100 pb-70">
        <div className="container">
          <div className="row">
            <div className="col-xl-2 col-lg-2 col-md-2 col-sm-2">
              <div className="list_footers">
                <div className="footer_lists">
                  <ul>
                    <li className="blue_line">
                      <Link to="/">@{currentYear} PatreonPass</Link>
                    </li>
                    <li>
                      <Link to="/contact">Contact</Link>
                    </li>
                  </ul>
                </div>
                <div className="social_icons_footer">
                  <a href={siteSettings.twitter_link} target="_blank" rel="noopener noreferrer">
                    <img src={xlogofooter} alt="Twitter Logo" />
                  </a>
                  <a href={siteSettings.insta_link} target="_blank" rel="noopener noreferrer">
                    <svg
                      className="instagram_icon"
                      xmlns="http://www.w3.org/2000/svg"
                      x="0px"
                      y="0px"
                      width="100"
                      height="100"
                      viewBox="0 0 50 50"
                    >
                      <path d="M 16 3 C 8.8324839 3 3 8.8324839 3 16 L 3 34 C 3 41.167516 8.8324839 47 16 47 L 34 47 C 41.167516 47 47 41.167516 47 34 L 47 16 C 47 8.8324839 41.167516 3 34 3 L 16 3 z M 16 5 L 34 5 C 40.086484 5 45 9.9135161 45 16 L 45 34 C 45 40.086484 40.086484 45 34 45 L 16 45 C 9.9135161 45 5 40.086484 5 34 L 5 16 C 5 9.9135161 9.9135161 5 16 5 z M 37 11 A 2 2 0 0 0 35 13 A 2 2 0 0 0 37 15 A 2 2 0 0 0 39 13 A 2 2 0 0 0 37 11 z M 25 14 C 18.936712 14 14 18.936712 14 25 C 14 31.063288 18.936712 36 25 36 C 31.063288 36 36 31.063288 36 25 C 36 18.936712 31.063288 14 25 14 z M 25 16 C 29.982407 16 34 20.017593 34 25 C 34 29.982407 29.982407 34 25 34 C 20.017593 34 16 29.982407 16 25 C 16 20.017593 20.017593 16 25 16 z"></path>
                    </svg>
                  </a>
                </div>
              </div>
            </div>
            <div className="col-xl-10 col-lg-10 col-md-10 col-sm-10">
              <div className="footer_right_menus">
                <ul className="l-footer-static__menu__col">
                  <li><Link to="/help">Help</Link></li>
                  <li><Link to="/about" target="_blank">About</Link></li>
                  <li><Link to="/terms" target="_blank">Terms of Service</Link></li>
                  <li><Link to="/privacy" target="_blank">Privacy</Link></li>
                  <li><Link to="/terms#complaints_policy" target="_blank">Complaints Policy</Link></li>
                  <li><Link to="/cookie-notice" target="_blank">Cookie Notice</Link></li>
                  <li><Link to="/dmca" target="_blank">DMCA</Link></li>
                  <li><Link to="/usc" target="_blank">USC 2257</Link></li>
                  <li><Link to="/contract" target="_blank">Standard Contract between Fan and Creator</Link></li>
                  <li><Link to="/transparency-center" target="_blank">Patreon Pass Safety & Transparency Center</Link></li>
                  <li><Link to="/anti-slavery" target="_blank">Anti-Slavery and Anti-Trafficking Statement</Link></li>
                  <li><Link to="/terms#acceptable_use_policy" target="_blank">Acceptable Use Policy</Link></li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

       {!isHelpPage && (
        <Link to="/help" className="help_support">
          <span className="tooltip">Help and support</span>
          <img src={supporticon} alt="Support Icon" />
        </Link>
      )}

    </footer>
  );
};

export default Footer;
